//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  data() {
    return {
      confirm_show: false,
      confirm_title: "是否退出",
      login_peo_name: "未登录",
      toast: {
        dialog: false,
        text: ""
      },
      form_login: {
        //登录
        stu_id: "",
        pass_word: "",
        dialog: false
      },
      form_register: {
        //注册
        stu_id: "",
        pass_word: "",
        stu_name: "",
        class_id: "",
        class_name: "",
        phone: "",
        tip_id: "",
        tip_name: "",
        tip_answer: "",
        dialog: false
      },
      form_suggestions: {
        stu_ctn: "",
        dialog: false
      },
      form_alt: {
        //修改密码
        stu_id: "",
        pass_word: "",
        tip_id: "",
        tip_answer: "",
        dialog: false
      },
      class_list: [],
      tip_list: []
    };
  },
  mounted() {
    if (localStorage.getItem("wkt_login_peo")) {
      this.login_peo_name = JSON.parse(
        localStorage.getItem("wkt_login_peo")
      ).stu_name;
    } else {
      this.login_peo_name = "未登录";
    }
    this.get_stu_class();
  },
  methods: {
    login_in() {
      //登录
      if (this.form_login.stu_id == "" || this.form_login.pass_word == "") {
        this.toast.dialog = true;
        this.toast.text = "请完善表单";
        return;
      }

      let formData = new FormData();
      formData.append("action_name", "login_stu");
      formData.append("stu_id", this.form_login.stu_id);
      formData.append("pass_word", this.form_login.pass_word);
      this.$http({
        url: "/login.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status == 1) {
          this.form_login.dialog = false;
          this.login_peo_name = res.data.data[0].stu_name;
          this.form_login.stu_id = "";
          this.form_login.pass_word = "";
          localStorage.setItem(
            "wkt_login_peo",
            JSON.stringify(res.data.data[0])
          );
        }

        this.toast.dialog = true;
        this.toast.text = res.data.info;
      });
    },
    onCancel() {
      console.log("on cancel");
    },
    open_login_state() {
      //打开登录
      if (localStorage.getItem("wkt_login_peo")) {
        this.toast.dialog = true;
        this.toast.text = "已登录请退出";
      } else {
        this.form_login.dialog = true;
      }
    },
    exit() {
      //退出
      if (localStorage.getItem("wkt_login_peo")) {
        this.confirm_show = true;
      } else {
        this.toast.text = "尚未登录";
        this.toast.dialog = true;
      }
    },
    onConfirm() {
      //退出提示
      localStorage.removeItem("wkt_login_peo");
      this.toast.text = "已退出";
      this.toast.dialog = true;
      this.login_peo_name = "未登录";
    },
    form_register_up() {
      //注册
      let re = /^[\u4E00-\u9FA5]+$/;
      if (
        this.form_register.stu_id == "" ||
        this.form_register.pass == "" ||
        this.form_register.name == "" ||
        this.form_register.class_id == "" ||
        this.form_register.phone == "" ||
        this.form_register.tip_id == "" ||
        this.form_register.tip_answer == ""
      ) {
        this.toast.text = "请完善信息";
        this.toast.dialog = true;
        return;
      }

      if (this.form_register.stu_id.length < 9) {
        this.toast.text = "学号不得少于九位数字";
        this.toast.dialog = true;
        return;
      }

      if (this.form_register.pass_word == this.form_register.stu_id) {
        this.toast.text = "密码不得与学号相同";
        this.toast.dialog = true;
        return;
      }

      if (this.form_register.pass_word < 6) {
        this.toast.text = "密码的不得少于六位";
        this.toast.dialog = true;
        return;
      }

      if (re.test(this.form_register.stu_name) == false) {
        this.toast.text = "请输入中文姓名";
        this.toast.dialog = true;
        return;
      }

      let Expression = /^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[^4]{1}\d{8}$|^17[0,6,7,8]{1}\d{8}$|^18[\d]{9}$/;
      if (!Expression.test(this.form_register.phone)) {
        this.toast.text = "手机号码格式不正确";
        this.toast.dialog = true;
        return;
      }

      let formData = new FormData();
      formData.append("action_type", "stu_info");
      formData.append("stu_id", this.form_register.stu_id);
      formData.append("pass_word", this.form_register.pass_word);
      formData.append("stu_name", this.form_register.stu_name);
      formData.append("class_id", this.form_register.class_id);
      formData.append("class_name", this.form_register.class_name);
      formData.append("phone", this.form_register.phone);
      formData.append("tip_id", this.form_register.tip_id);
      formData.append("tip_name", this.form_register.tip_name);
      formData.append("tip_answer", this.form_register.tip_answer);

      this.$http({
        url: "/upload/common.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status == 1) {
          this.form_register.dialog = false;
          this.form_register.stu_id = "";
          this.form_register.pass_word = "";
          this.form_register.stu_name = "";
          this.form_register.class_id = "";
          this.form_register.phone = "";
          this.form_register.tip_id = "";
          this.form_register.tip_answer = "";
        }

        this.toast.dialog = true;
        this.toast.text = res.data.info;
      });
    },
    form_alt_up() {
      //修改密码
      if (
        this.form_alt.stu_id == "" ||
        this.form_alt.pass_word == "" ||
        this.form_alt.tip_id == "" ||
        this.form_alt.tip_answer == ""
      ) {
        this.toast.dialog = true;
        this.toast.text = "请完善表单";
        return;
      }

      if (this.form_alt.pass_word < 6) {
        this.toast.text = "密码的不得少于六位";
        this.toast.dialog = true;
        return;
      }

      let formData = new FormData();
      formData.append("action_type", "stu_alt_pass");
      formData.append("stu_id", this.form_alt.stu_id);
      formData.append("pass_word", this.form_alt.pass_word);
      formData.append("tip_id", this.form_alt.tip_id);
      formData.append("tip_answer", this.form_alt.tip_answer);
      this.$http({
        url: "/update/common.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status == 1) {
          this.form_alt.dialog = false;
          this.form_alt.stu_id = "";
          this.form_alt.pass_word = "";
          this.form_alt.tip_id = "";
          this.form_alt.tip_answer = "";
        }
        this.toast.dialog = true;
        this.toast.text = res.data.info;
      });
    },
    get_stu_class() {
      //获取班级数据
      this.$http
        .get("/search/common.php", {
          params: {
            form: "stu_class"
          }
        })
        .then(res => {
          if (res.data.status == 1) {
            res.data.data.map((item, index) => {
              let obj = {
                key: item.id,
                value: item.name
              };
              this.class_list.push(obj);
            });
          }
        });

      //获取密保数据
      this.$http
        .get("/search/common.php", {
          params: {
            form: "stu_altpass_tip"
          }
        })
        .then(res => {
          if (res.data.status == 1) {
            res.data.data.map((item, index) => {
              let obj = {
                key: item.id,
                value: item.name
              };
              this.tip_list.push(obj);
            });
          }
        });
    },
    getClassName(class_id) {
      // 获取班级名称
      this.class_list.map((item, index) => {
        if (class_id == item.key) {
          this.form_register.class_name = item.value;
        }
      });
    },
    getTipName(tip_id) {
      // 获取修改密码提示名称
      this.tip_list.map((item, index) => {
        if (tip_id == item.key) {
          this.form_register.tip_name = item.value;
        }
      });
    },
    form_suggestions_up() {
      if (!localStorage.getItem("wkt_login_peo")) {
        this.toast.text = "请登录";
        this.toast.dialog = true;
        return;
      }
      if (!this.form_suggestions) {
        this.toast.text = "请输入";
        this.toast.dialog = true;
        return;
      }

      let formData = new FormData();
      formData.append("action_type", "stu_up_options");
      formData.append(
        "stu_name",
        JSON.parse(localStorage.getItem("wkt_login_peo")).stu_name
      );
      formData.append("stu_ctn", this.form_suggestions.stu_ctn);

      this.$http({
        url: "/upload/common.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status == 1) {
          this.form_suggestions.dialog = false;
          this.form_suggestions.stu_ctn = "";
        }
        this.toast.dialog = true;
        this.toast.text = res.data.info;
      });
    },

    enter_path(path) {
      if (path == "/list_my_options") {
        if (!localStorage.getItem("wkt_login_peo")) {
          this.toast.dialog = true;
          this.toast.text = "请登录";
          return;
        }
      }
      //页面跳转
      this.$router.push({
        path: path
        // query: item
      });
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/my.vue